import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ExcelImportPreview, ExcelImportResult } from '../models/import.model';

@Injectable({ providedIn: 'root' })
export class ImportService {
  private http = inject(HttpClient);
  private base = `${environment.apiUrl}/Import`;

  preview(file: File): Observable<ExcelImportPreview> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<ExcelImportPreview>(`${this.base}/preview`, formData).pipe(catchError(this.handle));
  }

  import(file: File): Observable<ExcelImportResult> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<ExcelImportResult>(`${this.base}/excel`, formData).pipe(catchError(this.handle));
  }

  clearAllData(): Observable<{message: string}> {
    return this.http.delete<{message: string}>(`${this.base}/clear`).pipe(catchError(this.handle));
  }

  clearAndImport(file: File): Observable<ExcelImportResult> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<ExcelImportResult>(`${this.base}/clear-and-import`, formData).pipe(catchError(this.handle));
  }

  private handle(err: any) {
    return throwError(() => err);
  }
}
